import { render, staticRenderFns } from "./DataTableVisualizar.vue?vue&type=template&id=2552bad6&scoped=true"
import script from "./DataTableVisualizar.vue?vue&type=script&lang=js"
export * from "./DataTableVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552bad6",
  null
  
)

export default component.exports